
/*add to cart product - variant */

function action_update_cart(qty,var_id,last_var_id=''){
    if(var_id){
      CartJS.addItem(var_id, qty, {},{
          "success": function(data, textStatus, jqxhr) {
            var success_msg = '<span class="success_message">Product Added to cart<p><a href="/cart">View Cart</a></p></span>';
             showMsg = document.querySelector(".modal-add-cart");
             showMsg.innerHTML += success_msg;
             $(".modal-add-cart").show();
             $(".err_message").remove();
             setTimeout(function(){
                $(".modal-add-cart").hide();
                $(".success_message").remove();
            }, 5000);
          },
          "error": function(jqxhr, textStatus, errorThrown) {
              if (jqxhr.responseJSON && jqxhr.responseJSON.status == 422) {
                    var errmsg = jqxhr.responseJSON.description;
              }
              if(errmsg && errmsg != undefined){
                var err_msg = '<span class="err_message">This size not available now</span>';
                erroMsg = document.querySelector(".modal-add-cart");
                erroMsg.innerHTML += err_msg;
                $(".modal-add-cart").show();
                $(".success_message").remove();
                setTimeout(function(){
                    $(".modal-add-cart").hide();
                    $(".err_message").remove();
                }, 5000);
              }
          }
      });
    }
}

$(".modal-add-cart").hide();
$(".success_message").remove();
$(".err_message").remove();

$(document).ready(function(){
  $(document).on("click",".add-to-cart",function(){
     var variant_id = $(this).attr("data-id");
     console.log(variant_id)
      if(variant_id){
        //action_update_cart(1,variant_id,variant_id);
        $("input[name=id]").val(variant_id);
        document.getElementById("quick-add-1234").click();
        //$('.drawer').addClass('active')

        setTimeout(function(){
          if ('Nosto' in window && 'nostojs' in window) {
          Nosto.reloadCart().then(function () {
            nostojs(function(api) {
              api.createRecommendationRequest({includeTagging: true})
                .setElements(['nosto-minicart'])
                .loadRecommendations();
                console.log('nosto');
                $( "#nosto-minicart .slick-next" ).trigger( "click" );
                setTimeout(function(){
                    $( "#nosto-minicart .slick-next" ).trigger( "click" );
                    setTimeout(function(){
                       $( "#nosto-minicart .slick-next" ).trigger( "click" );
                    },300)
                },300)
            });
          });
         }
        },1100) 
      }
  });
});

$(document).on('cart.requestComplete', function(event, cart) {
    $(".cart-count-bubble span").html(cart.item_count);
});

 $(document).on("click",".boost-pfs-filter-tree-desktop-button button",function(){
  $(this).toggleClass('active');
 })